import React, { useState } from 'react';
import { orderApi } from '../../lib/orderApi';
import { redButton } from '../PageShell';

const inputStyle = { width: '100%', background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.25)', color: '#F5F5F0', padding: '11px 13px', fontSize: '13px', outline: 'none' };

export const OfferPanel = ({ isOpen, mktCount }) => {
  const [offer, setOffer] = useState({ subject: '', message: '' });
  const [offerMsg, setOfferMsg] = useState('');
  const [offerBusy, setOfferBusy] = useState(false);

  if (!isOpen) return null;

  const sendOffer = async () => {
    if (!offer.subject.trim() || !offer.message.trim()) { setOfferMsg('Escribe asunto y mensaje.'); return; }
    setOfferBusy(true); setOfferMsg('');
    try {
      const { data } = await orderApi.post('/admin/send-offer', { subject: offer.subject.trim(), message: offer.message.trim() });
      setOfferMsg(`✓ Enviado a ${data.sent} de ${data.total} suscriptores.`);
      setOffer({ subject: '', message: '' });
    } catch (e) {
      setOfferMsg('No se pudo enviar. ' + (e.response?.data?.detail || ''));
    } finally { setOfferBusy(false); }
  };

  return (
    <div className="mt-5 p-5" style={{ background: '#141414', border: '1px solid rgba(201,168,76,0.3)' }} data-testid="offer-panel">
      <h3 className="font-display" style={{ fontSize: '18px', fontWeight: 700, color: '#F5F5F0' }}>Enviar oferta por email</h3>
      <p className="font-body mt-1" style={{ fontSize: '12px', color: '#C2C1B6' }}>
        Se enviará a {mktCount != null ? mktCount : '…'} cliente(s) que aceptaron recibir ofertas.
      </p>
      <input
        value={offer.subject}
        onChange={(e) => setOffer({ ...offer, subject: e.target.value })}
        placeholder="Asunto (ej. 20% de descuento este viernes)"
        className="mt-3"
        style={inputStyle}
        data-testid="offer-subject"
      />
      <textarea
        value={offer.message}
        onChange={(e) => setOffer({ ...offer, message: e.target.value })}
        placeholder="Mensaje de la oferta…"
        rows={4}
        className="mt-3"
        style={inputStyle}
        data-testid="offer-message"
      />
      <div className="flex items-center gap-4 mt-3">
        <button onClick={sendOffer} disabled={offerBusy} style={{ ...redButton, opacity: offerBusy ? 0.6 : 1 }} data-testid="offer-send">
          {offerBusy ? 'Enviando…' : 'Enviar oferta'}
        </button>
        {offerMsg && (
          <span className="font-body" style={{ fontSize: '12px', color: offerMsg.startsWith('✓') ? '#7FB77E' : '#E0736F' }} data-testid="offer-result">
            {offerMsg}
          </span>
        )}
      </div>
    </div>
  );
};
